/**
 * useFullscreen
 * 
 * @Author: Focci
 * @Date: 2023-06-23 11:50:55
 * @Last Modified by: Focci
 * @Last Modified time: 2023-06-23 11:50:55
 */

import screenfull from 'screenfull'
import { isFunction } from 'lodash-es'
import { useCallback, useEffect, useState } from 'react'

export default function useFullscreen(container) {
  const [isFullscreen, setIsFullscreen] = useState(false)
  const handleChange = useCallback(() => {
    screenfull.isEnabled && setIsFullscreen(!isFullscreen)
  }, [isFullscreen])

  function handle() {
    if (screenfull.isEnabled) {
      isFullscreen 
        ? screenfull.exit()
        : screenfull.request(container)
    }
  }

  useEffect(() => {
    const pass = isFunction(screenfull?.on)
    
    pass && screenfull.on('change', handleChange)
    return () => pass && screenfull.off('change', handleChange)
  }, [handleChange])

  return {
    handle,
    isFullscreen,
  }
}
